import { ToolkitPropertyEnum, isDefined } from '@aloft/toolkit-shared';

import { getPropertyPinStatus } from '../../../utils/getPropertyPinStatus.ts';
import { PropertyPin } from '../types.ts';

export const getPropertyPinIcon = (
  status: ToolkitPropertyEnum<'ListingStatusType'> | 'Subject',
  isFocused: boolean,
  idx?: number,
): PropertyPin => {
  const statusKey = getPropertyPinStatus(
    (status as ToolkitPropertyEnum<'ListingStatusType'>) ?? '',
  );
  const idxKey = isDefined(idx) ? ((idx < 10 ? `-${idx}` : '-9+') as `-${number}` | `-9+`) : '';
  const focusKey = isFocused ? '-F' : '';

  return statusKey === 'Subject' ? `${statusKey}${focusKey}` : `${statusKey}${idxKey}${focusKey}`;
};
